var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo48V1 = function SvgLogo48V1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4519 12.3336L1.15001 45.7622C0.837596 46.3055 1.02776 47.0119 1.58468 47.2971C12.7094 53.0293 26.4829 49.0629 32.8128 38.1148L52.6852 3.69461C41.3974 -2.8118 26.9719 1.04586 20.4519 12.3336Z",
    fill: "#0071CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9343 3.70784L20.4648 5.17737L27.2169 11.9295L28.6865 10.46L21.9343 3.70784Z",
    fill: "#0071CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8814 6.24833C21.6069 6.24833 23.0056 4.84959 23.0056 3.12417C23.0056 1.39874 21.6069 0 19.8814 0C18.156 0 16.7573 1.39874 16.7573 3.12417C16.7573 4.84959 18.156 6.24833 19.8814 6.24833Z",
    fill: "#0071CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3006 24.1376V62.7686C17.3006 63.3934 17.8168 63.9096 18.4552 63.8688C30.9518 63.2711 40.9084 52.9478 40.9084 40.3017V0.529724C27.8548 0.529724 17.3006 11.0976 17.3006 24.1376Z",
    fill: "#0190F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5677 24.1375C24.5677 33.1569 31.8755 40.4647 40.8949 40.4647V7.81036C31.8755 7.81036 24.5677 15.1182 24.5677 24.1375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4562 28.3755L40.8948 24.124V40.4511C47.9038 40.4511 53.8669 36.0365 56.1897 29.829C56.407 29.2313 56.081 28.5657 55.4562 28.3755Z",
    fill: "#FF9A07"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1987 16.4222C60.0066 7.17197 51.2182 0.529724 40.8948 0.529724V24.124L62.4652 17.8349C63.0628 17.6583 63.416 17.0199 63.1987 16.4222Z",
    fill: "#FF9A07"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1304 19.9675C35.5632 19.9675 36.7248 18.8059 36.7248 17.373C36.7248 15.9402 35.5632 14.7786 34.1304 14.7786C32.6975 14.7786 31.5359 15.9402 31.5359 17.373C31.5359 18.8059 32.6975 19.9675 34.1304 19.9675Z",
    fill: "#07133D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo48V1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_48_v1.9148abac2427c7be7fc38f0c9a006718.svg";